import { render, staticRenderFns } from "./VDialog.vue?vue&type=template&id=09502580"
import script from "./VDialog.vue?vue&type=script&lang=js"
export * from "./VDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports